import { Typography } from '@mui/material'
import { useState, type FC } from 'react'
import { useTranslation } from 'react-i18next'

import type { UserUpdatePayloadDto } from '@hcr/api/consumer'
import { isNotUndefined } from '@hcr/utils'

import { useUserDetails } from '../../../contexts'
import { useCountriesQuery } from '../../../hooks'
import { Path } from '../../../models'
import { to, selectCountriesSortedByTranslationAsc } from '../../../utils'
import { LayoutNavigationBackError500 } from '../../common'

import { AccountEditEmailConfirmation } from './account-edit-email'
import { AccountEditForm } from './account-edit-form'
import { AccountEditLoading } from './AccountEditLoading'
import { LayoutAccountEdit } from './common'

const BACK_NAVIGATION_PATH = to(Path.Account)

export const AccountEdit: FC = () => {
  const { t } = useTranslation()
  const countries = useCountriesQuery({ select: selectCountriesSortedByTranslationAsc })
  const userDetails = useUserDetails()

  const [accountEditFromData, setAccountEditFromData] = useState<UserUpdatePayloadDto>({
    country_code: userDetails.data?.country_code ?? '',
    phone: userDetails.data?.phone ?? '',
    update_to_email: '',
  })
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false)

  if (countries.isError || userDetails.isError) {
    return <LayoutNavigationBackError500 to={BACK_NAVIGATION_PATH} />
  }

  if (showEmailConfirmation) {
    return (
      <AccountEditEmailConfirmation
        accountEditFromData={accountEditFromData}
        setShowEmailConfirmation={setShowEmailConfirmation}
      />
    )
  }

  if (countries.isSuccess && userDetails.isSuccess && isNotUndefined(userDetails.data)) {
    return (
      <LayoutAccountEdit
        backNavigationPath={BACK_NAVIGATION_PATH}
        headline={
          <Typography component='h1' variant='headlineS'>
            {t('account-edit.contact-details')}
          </Typography>
        }
        form={
          <AccountEditForm
            setAccountEditFromData={setAccountEditFromData}
            setShowEmailConfirmation={setShowEmailConfirmation}
            userDetails={userDetails.data}
          />
        }
      />
    )
  }

  return <AccountEditLoading to={BACK_NAVIGATION_PATH} />
}
